import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

function Footer2() {
  return (
    <Box
      sx={{
        backgroundColor: '#1111',
        color: '#9999',
        px: 2,
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mt: 'auto',
      }}
    >
      {/* Links Container */}
      <Box
        sx={{
          width: '100%',
          maxWidth: 900,
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: 4,
          mb: 3,
        }}
      >
        {[
          { to: '/', label: 'Home' },
          { to: '/about-us', label: 'About' },
          { to: '/chatbot', label: 'Vimitra' },
          {to: '/achievements', label: 'Achievements'},
          {to: '/blog', label: 'Blogs'},
          // { to: '/enterprise-ai-solutions', label: 'Enterprise AI' },
          { to: '/ai-program-page', label: 'AI Immersion' },
          { to: '/faqs', label: 'FAQs' },
          { to: '/careers', label: 'Careers' },
          { to: '/contact-us', label: 'Contact' },
          { to: '/community', label: 'Community' },
          { to: '/customer-support', label: 'Help' },
          { to: '/terms-of-service', label: 'Terms' },
          { to: '/privacy-policy', label: 'Privacy' },
          { to: '/cookies-policy', label: 'Cookies' },
          { to: '/refunds-and-cancellations-policy', label: 'Refunds' },
        ].map((link) => (
          <Link
            key={link.to}
            to={link.to}
            style={{
              color: '#9999',
              textDecoration: 'none',
              padding: '5px',
              letterSpacing: 2,
              fontSize: 'clamp(0.75rem, 2vw, 1rem)',
            }}
          >
            {link.label}
          </Link>
        ))}
      </Box>

      {/* Copyright */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          flexDirection: { xs: 'column', sm: 'row' },
        }}
      >
        <Typography
          variant="body2"
          component="h1"
          sx={{
            fontSize: 'clamp(0.8rem, 2vw, 1rem)',
            letterSpacing: 2,
            '&:hover': {
              color: 'white',
            },
          }}
        >
          © 2026 Anthrasync Inc. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
}

export default Footer2;
